import { usePathname, useRouter } from 'next/navigation';
import { useEvent, useUnit } from 'effector-react';
import { closeModalEvent, openModalEvent } from '@nx-frontend/shared/ui/modal';
import { changesUndoAllFx, getHasSidebarChangesFx } from '@nx-frontend/shared/store/change-events-store';
import { $isCustomizerMode } from '@nx-frontend/shared/store/portal-app';
import { ModalTitleSize, PopupType } from '@nx-frontend/shared/types';

export const useCustomizerCheckChanges = () => {
  const pathname = usePathname();
  const router = useRouter();
  const [isCustomizer] = useUnit([$isCustomizerMode]);
  const [openModal, closeModal, getHasSidebarChanges] = useEvent([
    openModalEvent,
    closeModalEvent,
    getHasSidebarChangesFx,
  ]);

  return (successFn: () => void) => {
    if (isCustomizer) {
      (async () => {
        const hasChanges = await getHasSidebarChanges();
        if (hasChanges) {
          openModal({
            title: 'You have unpublished changes',
            content: PopupType.CUSTOMIZER_UNPUBLISHED_CHANGES,
            showCloseButton: true,
            closeButtonSize: 20,
            titleSize: ModalTitleSize.LG,
            payload: {
              payloadType: PopupType.CUSTOMIZER_UNPUBLISHED_CHANGES,
              text: "You've updated your navigation (e.g., renamed items, added or removed pages). Publish now to keep your changes.",
              buttons: [
                {
                  text: 'Discard all changes',
                  main: false,
                  size: 'xl',
                  onClick: () => {
                    changesUndoAllFx();
                    closeModal();
                    successFn();
                  },
                },
                {
                  text: 'Publish changes',
                  main: true,
                  size: 'xl',
                  onClick: () => {
                    closeModal();
                    router.push(`${pathname}?open-publish-modal=true`);
                  },
                },
              ],
            },
          });
        } else {
          successFn();
        }
      })();
      return false;
    } else {
      successFn();
      return true;
    }
  };
};
